import styled from "styled-components";

export const SectionWrapper = styled.section`
  background-color: #f7f7f7;
  padding: 4rem 1.5rem;
`;

export const Content = styled.div`
  max-width: 700px;
  margin: 0 auto;
  background-color: white;
  padding: 3rem 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 1rem;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-top: 1.2rem;
  color: #444;
`;

export const Input = styled.input`
  padding: 0.8rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
`;

export const Textarea = styled.textarea`
  padding: 0.8rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
  min-height: 100px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`;

export const CheckboxLabel = styled.label`
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: #444;

  input {
    margin-right: 0.5rem;
  }
`;

export const SubmitButton = styled.button`
  margin-top: 2rem;
  background-color: #0077cc;
  color: white;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;
export const CheckboxWrapper = styled.div`
  margin-top: 1.5rem;
  font-size: 0.95rem;
  color: #444;

  a {
    color: #0077cc;
    text-decoration: underline;

    &:hover {
      color: #005fa3;
    }
  }

  input {
    margin-right: 0.4rem;
  }
`;
